"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _spauiPortal = _interopRequireDefault(require("@tencent/spaui-portal"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiLoading = _interopRequireDefault(require("@tencent/spaui-loading"));

var _pdfobject = require("../utils/pdfobject");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getWindowScrollTop = _spauiUtils.dom.getWindowScrollTop;
/**
 * @class
 */

var DOMComponent =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DOMComponent, _PureComponent);

  function DOMComponent(props) {
    var _this;

    _classCallCheck(this, DOMComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DOMComponent).call(this, props)); // 挂载pdf的结构id

    _defineProperty(_assertThisInitialized(_this), "setMaskHeight", function () {
      var maskHeight = Math.max((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.body.offsetHeight, window.innerHeight, (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.body.scrollHeight, (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.getElementsByTagName('html')[0].scrollHeight);

      if (_this.mask && maskHeight) {
        _this.mask.style.height = "".concat(maskHeight, "px");
      }
    });

    _this.pdfDomId = (0, _spauiUtils.getUniqueId)('spaui-viewer');

    _this.nullList();

    return _this;
  }

  _createClass(DOMComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setPreviewBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setPreviewBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.nullList();
    } // ref引用声明

  }, {
    key: "nullList",
    value: function nullList() {
      this.mask = null;
      this.content = null;
      this.image = null;
      this.loading = null;
    } // 设置内容区域的宽高跟位置

  }, {
    key: "setContentWidth",
    value: function setContentWidth() {
      var newWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var newHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var _this$props = this.props,
          _this$props$width = _this$props.width,
          width = _this$props$width === void 0 ? 0 : _this$props$width,
          _this$props$height = _this$props.height,
          height = _this$props$height === void 0 ? 0 : _this$props$height,
          setSize = _this$props.setSize,
          _this$props$autoFitSi = _this$props.autoFitSize,
          autoFitSize = _this$props$autoFitSi === void 0 ? true : _this$props$autoFitSi,
          _this$props$scroll = _this$props.scroll,
          scroll = _this$props$scroll === void 0 ? false : _this$props$scroll;

      var _width = newWidth || width;

      var _height = newHeight || height;

      var _scrollTop = 0;
      var sizeData = {};
      var windowWidth = 0;
      var windowHeight = 0;

      if (this.content) {
        var contentRect = this.content.getBoundingClientRect();

        if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window) {
          windowWidth = window.innerWidth;
          windowHeight = window.innerHeight;
        } // 如果没有宽度，就用内容区域的


        if (!_width) {
          _width = contentRect.width || 0;
        }

        if (!_height) {
          _height = contentRect.height || 0;
        }

        _width = parseFloat(_width) || 0;
        _height = parseFloat(_height) || 0;

        if ((0, _spauiUtils.isFunction)(setSize)) {
          sizeData = setSize(_width, _height);
          _width = sizeData.width;
          _height = sizeData.height;
        } else if (autoFitSize && !scroll && windowWidth > 0 && windowHeight > 0) {
          // 如果没有setSize且图片宽高超过了，就默认调整一下
          if (_width > windowWidth || _height > windowHeight) {
            if (_width / _height > windowWidth / windowHeight) {
              _height = _height * (windowWidth / _width);
              _width = windowWidth;
            } else {
              _width = _width * (windowHeight / _height);
              _height = windowHeight;
            }
          }
        }

        if (_width) {
          this.content.style.width = "".concat(_width, "px");
          this.content.style.marginLeft = "".concat(-_width / 2, "px");
        }

        if (_height) {
          _scrollTop = getWindowScrollTop();
          this.content.style.height = "".concat(_height, "px");
          this.content.style.marginTop = "".concat(_scrollTop - _height / 2, "px");
        } // 有图片的化，设置下图片


        if (this.image) {
          if (_width) {
            this.image.width = _width;
          }

          if (_height) {
            this.image.height = _height;
          }
        }
      }

      this.setMaskHeight();
    }
    /**
     * 设置蒙层的高度
     *
     * @memberof DOMComponent
     */

  }, {
    key: "setBodyOverflowHiddenClassName",
    // 隐藏滚动条
    value: function setBodyOverflowHiddenClassName() {
      var body = (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.getElementsByTagName('body')[0];
      var _this$props2 = this.props,
          show = _this$props2.show,
          scroll = _this$props2.scroll;
      var bodyClassName = body.className || '';
      var overflowHiddenClassName = 'spaui-viewer-overflow-hidden';
      var bodyClassNameList = bodyClassName.split(' ');
      var index = -1;

      if (show) {
        if (!scroll && !this.addBodyOverflowHiddenClassName) {
          bodyClassNameList.push(overflowHiddenClassName);
          this.addBodyOverflowHiddenClassName = true;
        }
      } else {
        if (this.addBodyOverflowHiddenClassName) {
          index = (0, _spauiUtils.indexOf)(bodyClassNameList, overflowHiddenClassName);

          if (index > -1) {
            bodyClassNameList.splice(index, 1);
            this.addBodyOverflowHiddenClassName = false;
          }
        }
      }

      body.className = bodyClassNameList.join(' ');
    } // 展示内容

  }, {
    key: "setPreviewBox",
    value: function setPreviewBox() {
      var _this2 = this;

      var _this$props3 = this.props,
          type = _this$props3.type,
          url = _this$props3.url,
          show = _this$props3.show,
          _this$props3$locale = _this$props3.locale,
          locale = _this$props3$locale === void 0 ? {} : _this$props3$locale;

      var hideLoading = function hideLoading() {
        if (_this2.loading && typeof _this2.loading.getDOMNode !== 'undefined' && _this2.loading.getDOMNode()) {
          _this2.loading.getDOMNode().style.display = 'none';
        }

        if (_this2.image) {
          _this2.image.setAttribute('width', 'auto');

          _this2.image.setAttribute('height', 'auto');
        }
      };

      var image = null;

      if (show) {
        if (type === 'image' && url) {
          // 这里需要提前设置下蒙层的高度，防止图片加载失败的时候，蒙层的高度没有正确设置的问题
          this.setMaskHeight();

          if (!(0, _pdfobject.isPDF)(url)) {
            image = new Image();

            image.onload = function () {
              hideLoading();

              _this2.setContentWidth();
            };

            image.onerror = function () {
              if (_this2.content) {
                _this2.content.innerHTML = locale.imageLoadFailLabel;
              }

              hideLoading();
            };

            image.src = url;
          } else {
            (0, _pdfobject.addPDFObject)(function () {
              var $id = document.getElementById(_this2.pdfDomId);

              if ($id) {
                $id.style.width = "".concat(Math.max(100, window.innerWidth * 0.9), "px");
                $id.style.height = "".concat(Math.max(200, window.innerHeight * 0.9), "px");
                (0, _pdfobject.showPDFObject)(_this2, url, _this2.pdfDomId);

                _this2.setContentWidth();
              }
            });
          }
        } else {
          this.setContentWidth();
        }
      }

      this.setBodyOverflowHiddenClassName();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props4 = this.props,
          show = _this$props4.show,
          onClose = _this$props4.onClose,
          children = _this$props4.children,
          maskClassName = _this$props4.maskClassName,
          _this$props4$contentC = _this$props4.contentClassName,
          contentClassName = _this$props4$contentC === void 0 ? '' : _this$props4$contentC,
          _this$props4$contentS = _this$props4.contentStyle,
          contentStyle = _this$props4$contentS === void 0 ? {} : _this$props4$contentS,
          type = _this$props4.type,
          url = _this$props4.url,
          enabledMaskClose = _this$props4.enabledMaskClose,
          devProps = _this$props4.devProps,
          CloseComponent = _this$props4.CloseComponent,
          DisplayComponent = _this$props4.DisplayComponent,
          _this$props4$classNam = _this$props4.classNameMap,
          classNameMap = _this$props4$classNam === void 0 ? {} : _this$props4$classNam;
      var _children = children;

      if (!show || type === 'image' && !url) {
        return null;
      }

      if (type === 'image') {
        if ((0, _pdfobject.isPDF)(url)) {
          // pdf结构
          _children = _react["default"].createElement("div", {
            id: this.pdfDomId
          });
        } else {
          // 图片结构
          _children = _react["default"].createElement("div", null, _react["default"].createElement(_spauiLoading["default"], {
            ref: function ref(el) {
              _this3.loading = el;
            }
          }), _react["default"].createElement(DisplayComponent, {
            type: type,
            data: {
              url: url
            },
            width: "0",
            height: "0",
            htmlRef: function htmlRef(el) {
              _this3.image = el;
            }
          }));
        }
      }

      return _react["default"].createElement(_spauiPortal["default"], (0, _spauiUtils.globalProps)(this.props, {
        className: classNameMap.ImageViewerClassName
      }, devProps[0], devProps[1]), _react["default"].createElement("div", {
        onClick: enabledMaskClose ? onClose : _spauiUtils.noop,
        className: (0, _classnames["default"])(classNameMap.ImageOverlayClassName, maskClassName),
        ref: function ref(el) {
          _this3.mask = el;
        }
      }), _react["default"].createElement("div", {
        className: (0, _classnames["default"])(classNameMap.ImageBodyClassName, contentClassName),
        ref: function ref(el) {
          _this3.content = el;
        },
        style: contentStyle
      }, _children), _react["default"].createElement(CloseComponent, _extends({}, this.props, {
        CloseComponent: null
      })));
    }
  }]);

  return DOMComponent;
}(_react.PureComponent);

var _default = DOMComponent;
exports["default"] = _default;